import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { initSentry, getDefaultSentryConfig } from '@raporgor/utils';
import { ErrorBoundary, DefaultErrorFallback } from '@raporgor/shared-ui';
import './index.css';
import App from './App.tsx';

// Initialize Sentry — release tek kaynak vite-plugin (SENTRY_RELEASE build-time embed).
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  const sentryConfig = getDefaultSentryConfig(sentryDsn, {
    deployable: 'adminpanel',
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    isDevelopment: import.meta.env.DEV,
  });
  initSentry(Sentry, sentryConfig);
}

// Error handler for ErrorBoundary
const handleError = (error: Error, errorInfo: React.ErrorInfo) => {
  console.error('[App Error]', error);
  if (sentryDsn) {
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo.componentStack },
    });
  }
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary onError={handleError} fallback={DefaultErrorFallback}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
